import React from 'react';
import styled from 'styled-components';
import { COLORS } from './styles';

const BlurWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  filter: blur(3px);
  opacity: 0.7;
  pointer-events: none;
`;

const ComingSoonOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  pointer-events: none;
  background: linear-gradient(135deg, rgba(15, 20, 25, 0.5) 0%, rgba(26, 31, 46, 0.5) 100%);
  backdrop-filter: blur(2px);
`;

const ComingSoonLabel = styled.div`
  border: 1px solid rgba(99, 102, 241, 0.4);
  color: #a5b4fc;
  padding: 12px 24px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(139, 92, 246, 0.15) 100%);
  box-shadow: 0 4px 24px rgba(99, 102, 241, 0.2);
`;

const BlurredComponent = ({ children }) => {
  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <BlurWrapper>{children}</BlurWrapper>
      <ComingSoonOverlay>
        <ComingSoonLabel>Coming Soon</ComingSoonLabel>
      </ComingSoonOverlay>
    </div>
  );
};

export default BlurredComponent; 